import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BorrowerState, ENVIRONMENT, PatchBorrowerStateRequest } from '@ld.consumer-portal/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface BorrowerStateResponse {
  success: boolean;
  data: BorrowerState | BorrowerState[];
}

@Injectable({ providedIn: 'root' })
export class BorrowerStateService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  private get mlaApiUrl(): string {
    return this.env.appSettings.mlaApiUrl || '';
  }

  getBorrowerState(loanId: string, borrowerId: string): Observable<BorrowerState | null> {
    const params = new HttpParams().set('mortgageId', loanId).set('borrowerId', borrowerId);

    return this.http.get<BorrowerStateResponse>(`${this.mlaApiUrl}api/v1/borrowerstate`, { params }).pipe(
      map((response) => {
        if (response?.success && response.data) {
          return Array.isArray(response.data) ? response.data[0] : response.data;
        }
        return null;
      })
    );
  }

  getAllBorrowerStates(loanId: string): Observable<BorrowerState[]> {
    const params = new HttpParams().set('mortgageId', loanId);

    return this.http.get<BorrowerStateResponse>(`${this.mlaApiUrl}api/v1/borrowerstate`, { params }).pipe(
      map((response) => {
        if (response?.success && response.data) {
          return Array.isArray(response.data) ? response.data : [response.data];
        }
        return [];
      })
    );
  }

  updateBorrowerState(request: PatchBorrowerStateRequest): Observable<void> {
    return this.http.patch<void>(`${this.mlaApiUrl}api/v1/borrowerstate`, request);
  }
}
